import {
  Company_Status,
  Company_User_Role,
  Company_User_Status,
  Organization_State,
  Type_Of_Organization,
} from "@generated/graphql";

export const ORGANIZATION_STATES: { id: Organization_State; displayName: string }[] = [
  {
    id: Organization_State.Active,
    displayName: "Действующая",
  },
  {
    id: Organization_State.Liquidating,
    displayName: "Ликвидируется",
  },
  {
    id: Organization_State.Liquidated,
    displayName: "Ликвидирована",
  },
  {
    id: Organization_State.Bankrupt,
    displayName: "Банкротство",
  },
  {
    id: Organization_State.Reorganizing,
    displayName: "В процессе присоединения к другому юрлицу",
  },
];

export const ORGANIZATION_TYPES = [
  {
    id: Type_Of_Organization.Legal,
    displayName: "Юридическое лицо",
  },
  {
    id: Type_Of_Organization.Individual,
    displayName: "Индивидуальные предприниматель",
  },
];

export const COMPANY_STATUS_TITLE: Record<Company_Status, string> = {
  [Company_Status.PartlyApproved]: "Частично подтверждена",
  [Company_Status.NotApproved]: "Не подтверждена",
  [Company_Status.Created]: "Создана",
  [Company_Status.Blocked]: "Заблокирована",
  [Company_Status.Approved]: "Подтверждена",
  [Company_Status.Pending]: "На проверке",
};

export const COMPANY_USER_ROLE_TITLE: Record<Company_User_Role, string> = {
  [Company_User_Role.Administrator]: "Администратор",
  [Company_User_Role.Hr]: "HR",
  [Company_User_Role.Methodologist]: "Методолог",
  [Company_User_Role.Reviewer]: "Ревьюер",
  [Company_User_Role.Supervisor]: "Руководитель",
};

export const COMPANY_USER_STATUS_TITLE: Record<Company_User_Status, string> = {
  [Company_User_Status.Active]: "Активен",
  [Company_User_Status.Deactivated]: "Деактивирован",
  [Company_User_Status.Pending]: "Ожидает",
};
